import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useBreadcrumbs, useUser } from '../hooks';
import { bindClick } from '../SiteUtil';
import { Header, Groupper, Table, Message, Button, Toolbar, Modal, Toast, Label, Field, Pagination } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import { Promoter, SetLoading, EventDate } from '../SiteClasses';
import { PromoterContactsTable } from '../components';
import UserAccess from '../UserAccess';
import moment from 'moment';
import API from '../API';

const PAGE_SIZE = 20;

var PromoterView = ()=>{
	var { hasAccess } = useUser();
	var params = useParams<{ pid: string }>();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [promoterData, setPromoterData] = useState<Promoter>(null);
	var [statusModal, setStatusModal] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [selectedStatus, setSelectedStatus] = useState<number | null>(null);
	var [events, setEvents] = useState<EventDate[]>(null);
	var [eventsLoading, setEventsLoading] = useState<boolean>(false);
	var [eventsPage, setEventsPage] = useState<number>(0);

	useEffect(()=>{
		setTitle('Promotor #'+parseInt(params.pid));
		API.getPromoter(parseInt(params.pid)).then(res=>{
			if(res.error) setLoadError(res.message);
			
			setPromoterData(res.data);
			getEvents();
		}).catch(err=>{
			setLoadError('Hubo un error cargando el promotor (LCL-1)');
		})
	}, [params.pid]);

	var getEvents = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || eventsPage) * PAGE_SIZE) : 0;
		
		setEventsLoading(true);
		API.getPromoterEvents(parseInt(params.pid), PAGE_SIZE, offset).then(res => {
			if(res.error) return setLoadError(res.message);
			return setEvents(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los eventos del promotor. (GPE-1)');
		}).finally(()=>{
			setEventsLoading(false);
		})
	};

	var onEventsPageChange = (page: number)=>{
		setEventsLoading(true)
		setEventsPage(page);
		getEvents(page);
	};

	var showStatusModal = ()=>{
		setSelectedStatus(promoterData.status_id);
		setStatusModal(true);
	};

	var updateStatus = (setLoading: SetLoading)=>{
		if(selectedStatus === undefined) return setModalPrompts(['Selecciona un estatus']);
		setLoading(true);
		API.updatePromoterStatus(promoterData.promoter_id, selectedStatus).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Se ha actualizado el estatus del promotor');

			var p = { ...promoterData };
			p.status_id = selectedStatus;
			setPromoterData(p);
			setStatusModal(false);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado actualizando el estatus (LCL-1)']);
		}).finally(()=>{	
			setLoading(false);
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!promoterData) return <Header text='Cargando datos' loading />

	return <div style={{ paddingLeft: 15, paddingRight: 15 }}>
		<Groupper title={'Información del Promotor'} width={400} style={{ marginTop: 15 }} fitted>
			<Toolbar>
				{hasAccess(UserAccess.EVENTS.EDIT_PROMOTERS) && <Toolbar.Item iconName='edit' text='Estatus'  onClick={showStatusModal} />}
			</Toolbar>
			<Table
				details
				striped
				data={[
					['ID', promoterData.promoter_id],
					['Nombre', promoterData.promoter_name],
					['Estado', <Label 
						color={promoterData.status_id ? 'yellow' : 'red'}
					>
						{promoterData.status_id ? 'No operado' : 'Sin Status'}
					</Label>],
					['Total de eventos', promoterData.events_count],
					['Fecha de creación', moment.unix(promoterData.date_created).format('DD/MM/YYYY HH:mm')]
				]}
			/>
		</Groupper>
		<Table
			title='Eventos'
			striped
			style={{ maxWidth: 800, margin: 'auto', marginTop: 20 }}
			className='first last'
			headers={['ID', 'Fecha', 'Nombre del Evento', 'Ciudad']}
			footer={(!!events && events.length >= PAGE_SIZE || eventsPage !== 0) && (
				<Table.Cell colSpan={4} row>
					<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
						<Pagination page={eventsPage} onPageChange={onEventsPageChange} hasNext={events?.length>=PAGE_SIZE} />
					</div>
				</Table.Cell>
			)}
			collapsingIndexes={[0, 3]}
		>
			{eventsLoading ? (
				<Table.Cell row className='empty' colSpan={4}>
					<Header loading text='Cargando eventos' />
				</Table.Cell>
			) : (
				events && events.length > 0 ? (
					events.map(event=>(
						<Table.Row
							selectable
							compact
							key={event.date_id}
							as={Link}
							to={`/events/${event.date_id}`}
							data={[
								event.date_id,
								moment.unix(event.date).format('DD/MM/YY HH:mm'),
								event.event_name,
								event.city,
							]}
						/>
					))
				) : (
					<Table.Cell row className='empty' colSpan={4}>
						No se encontraron eventos
					</Table.Cell>
				)
			)}
		</Table>
		{hasAccess(UserAccess.EVENTS.VIEW_PROMOTERS) && <PromoterContactsTable promoter_id={promoterData.promoter_id} />}
		<Modal open={statusModal} onClose={bindClick(setStatusModal, false)} size='mini'>
			<Modal.Header>Editar estatus</Modal.Header>
			<Modal.Content>		
				<Field label='Estatus'>
					<Dropdown 
						placeholder='Selecciona un estatus'
						selection
						options={[
							{ text: 'Sin Status', value: 'null' },
							{ text: 'No Operado', value: 255 }
						]}
						onChange={(e, { value }) => setSelectedStatus(value === 'null' ? null : value as number)}
						defaultValue={selectedStatus === null ? 'null' : selectedStatus}
					/>
				</Field>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cancelar' onClick={bindClick(setStatusModal, false)} />
				<Button text='Guardar' color='black' onClick={updateStatus} loading={false} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default PromoterView;
